/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    this.countdown();
    this.accordion();
    this.inViewport();
  }


  countdown() {
    const elts = document.querySelectorAll("[data-countdown]");

    if (elts) {
      elts.forEach((el) => {
        // Set the date we're counting down to
        const countDownDate = new Date(el.dataset.countdown).getTime();

        function getTime() {
          const now = Date.now();

          if (now >= countDownDate) {
            return {
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
            };
          }

          const distance = countDownDate - now;

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          const minutes = Math.floor(
            (distance % (1000 * 60 * 60)) / (1000 * 60)
          );
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          return {
            days,
            hours,
            minutes,
            seconds,
          };
        }

        // el.addEventListener("inview", () => {
        // setTimeout(() => {
          const time = getTime();

          for (const [key, value] of Object.entries(time)) {
            gsap.to(el.querySelector(`.${key}`), {
              autoAlpha: 1,
            });
            const countdown = { val: value > 100 ? 100 : 0 };
            gsap.to(countdown, {
              val: value,
              duration: 1,
              ease: "power1.out",
              onUpdate: () => {
                const value = Math.floor(countdown.val);
                const span = el
                  .querySelector(`.${key}`)
                  .querySelector(".value ");
                const val = new String(value < 10 ? `0${value}` : value);
                span.textContent = val;
              },
            });
          }

          setTimeout(() => {
            const x = setInterval(function () {
              const time = getTime();
              for (const [key, value] of Object.entries(time)) {
                const span = el
                  .querySelector(`.${key}`)
                  .querySelector(".value");
                const val = new String(value < 10 ? `0${value}` : value);
                span.textContent = val;
              }
            }, 1000);
          }, 1000);
        // }, 500);
        // });
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll('.accordion');

    if( elts ) {
      elts.forEach(el => {
        const items = el.querySelectorAll('.accordion-item')
        const triggers = el.querySelectorAll('.accordion-header')
        const contents = el.querySelectorAll('.accordion-content');

        if( items && triggers && contents ) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener('click', e => {
              e.preventDefault();

              items[i].classList.toggle('show');

              const h = items[i].classList.contains('show') ? contents[i].children[0].offsetHeight : 0;

              gsap.to(contents[i], {
                duration: 0.3,
                ease: 'circ.inOut',
                height: h,
                autoAlpha: items[i].classList.contains('show') ? 1 : 0
              })
            })
          })
        }
      })
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
